import {
    ChangeDetectorRef,
    DestroyRef,
    Directive,
    HostBinding,
    HostListener,
    inject,
    Input,
    OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { QWYK_TABLE } from './table.component';

@Directive({
    standalone: true,
    selector: '[qwykSortableColumn]',
})
export class QwykSortableColumnDirective implements OnInit {
    @Input('qwykSortableColumn') field: string | null | undefined;

    private readonly _table = inject(QWYK_TABLE);
    private readonly _cdr = inject(ChangeDetectorRef);
    private readonly _destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this._table._sortState$
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(() => this._cdr.markForCheck());
    }

    @HostBinding('class.qwyk-sortable')
    get sortable(): boolean {
        return !!this.field;
    }

    @HostBinding('class.qwyk-sort-asc')
    get isAscActive(): boolean {
        return !!this.field && this._table._sortField === this.field && this._table._sortOrder === 1;
    }

    @HostBinding('class.qwyk-sort-desc')
    get isDescActive(): boolean {
        return !!this.field && this._table._sortField === this.field && this._table._sortOrder === -1;
    }

    @HostListener('click')
    onClick(): void {
        // click is intentionally NOT handled here — sort is triggered by <qwyk-sort-icon> only
    }
}
